import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import Decimal from 'decimal.js';
import { MAX_LIMIT } from 'modules/common/constants';
import { ModalContext } from 'App';
import * as c from '../constant';
import * as actions from '../action';

function UpdateQuantityModal({
  updateQuantityFees,
  // getNewOtherFeesList,
  updateList,
  id,
  // history,
  getSingleNewOtherFees,
  getQuantityCalculationList,
  updating,
  // ordinanceRevisionId,
}) {
  const [formData, setFormData] = useState({
    multiplier: '',
    amount: '',
  });

  const validateForm = useFormValidator(formData, {
    multiplier: 'required|text_underscore',
    amount: 'required|amount',
  });

  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const newOtherFeesId = _.get(updateList, 'bpls_other_fee_id');

    const args = {
      ...formData,
      multiplier: _.get(formData, 'multiplier').toLowerCase(),
    };

    updateQuantityFees(id, newOtherFeesId, args, () => {
      setModal({ isOpen: false });
      // getNewOtherFeesList({ ordinance_revision_id: ordinanceRevisionId });
      getSingleNewOtherFees(newOtherFeesId);
      // history.push(`/bpls/tax-revenue/new-other-fees/${newOtherFeesId}`);
      getQuantityCalculationList(newOtherFeesId);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
      };
      setFormData(_.pick(args, _.keys(c.FORM_DATA)));
    }
  };

  useEffect(() => {
    onSetFormData();
  }, []);

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Multiplier: {validateForm.renderMessage('multiplier')}
            </label>
            <input
              className="form-control"
              type="text"
              name="multiplier"
              onChange={onChange}
              placeholder="Ex. code_multiplier"
              // style={{ textTransform: 'lowercase' }}
              value={_.get(formData, 'multiplier')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Amount: {validateForm.renderMessage('amount')}
            </label>
            <NumberFormat
              name="amount"
              id="amount"
              placeholder="0.00"
              className="form-control"
              onValueChange={(values) => {
                const { value } = values;
                const props = {
                  target: {
                    name: 'amount',
                    value,
                  },
                };
                onChange(props);
              }}
              displayType="input"
              decimalScale={2}
              isNumericString
              allowNegative
              thousandSeparator
              allowLeadingZeros
              prefix="₱ "
              value={_.get(formData, 'amount')}
              isAllowed={(values) => {
                const { value } = values;
                if (!value) return true;
                const val = new Decimal(value);
                const max = new Decimal(MAX_LIMIT);
                return value === undefined || val.lte(max);
              }}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary     mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>{' '}
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateQuantityModal.propTypes = {
  updateList: PropTypes.instanceOf(Object).isRequired,
  updateQuantityFees: PropTypes.instanceOf(Function).isRequired,
  // getNewOtherFeesList: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  // history: PropTypes.instanceOf(Object).isRequired,
  getSingleNewOtherFees: PropTypes.instanceOf(Function).isRequired,
  getQuantityCalculationList: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
  // ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_QUANTITY_FEES) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateQuantityModal);
